

















































































































































































































































































































































































































import { Vue, mixpanelEvents, photosUrlEnum } from "../../constants/constants";
import {
ifItemSizeExist,
toFixedPrice,
counter,
removeClassFromSelector,
closestByClass,
pushMixpanelEvent,
updatePhotosURL,
} from "../../helpers";
import { genericErrorsEnum } from "../../models/basket.model";
import { staticContent } from "../../localisation/detect-lang";
import { FlatExtraCategories } from "../../models/restaurant.model";
import * as moment from "moment";
var modalOpened = false;

export default Vue.component("item-modal-template", {
data() {
  return {
    staticContent,
    ifItemSizeExist,
    toFixedPrice,
    counter,
    removeClassFromSelector,
    closestByClass,
    pushMixpanelEvent,
    updatePhotosURL,
    mixpanelEvents,
    genericErrorsEnum,
    photosUrlEnum
  };
},
props: {},
computed: {

  disableOrder(){
    return ( this.userAreaObj ? this.userAreaObj.data.orderingEnabled : true )
            && this.itemModal.itemData.availability.availableInBranch
            && this.itemModal.itemData.availability.availableInCurrentMenu
            && this.itemModal.itemData.availability.timeAvailability.availableNow
            && this.itemModal.itemData.menuAvailableOnTime
            && this.itemModal.itemData.availableOnTime
            && this.itemModal.itemData.availability.availableForDelivery
            && this.itemModal.itemData.categoryAvailableForDelivery
            && this.orderingEnabled
            && this.itemModal.itemData.menuAvailableForOnlineOrering
            && this.doesDeliverToUser;
  },
  flattenExtraCategoriesSizes(){
    let excatSizesArr=Object.values(this.itemModal.flatExtraCategories).reduce((acc,a)=>acc.concat(a.flatSizes), [] );
    return  Object.assign({},...excatSizesArr)
  },
  flattenSelectedItems(){
  return Object.values(this.itemModal.flatExtraCategories).reduce((acc,a)=>acc.concat(a.selectedItems), [] );
  },
  moment(){
    return moment;
  },
  bindConditionalClasses() {
    return this.$root.bindConditionalClasses;
  },
  userAreaObj() {
    return this.$root.userArea;
  },
  hasBasketInRestaurant() {
    return this.$root.hasBasketInRestaurant;
  },
  flattenDeliveryAreaZones() {
    return this.$root.flattenDeliveryAreaZones;
  },
  areaZonesSelected() {
    return this.$root.areaZonesSelected;
  },
  isRestaurantWithinDeliveryHours() {
    return this.$root.isRestaurantWithinDeliveryHours;
  },
  restaurantInfo() {
    return this.$root.restaurantPage.restHeaderObj;
  },
  profile() {
      return this.$store.getters.getProfileData;
    },
  isGroupLocked() {
    return this.$root.isGroupLocked;
  },
  isGroupOrderPage() {
    return this.$root.isGroupOrderPage;
  },
  groupBasket() {
    return this.$root.groupBasket;
  },
  itemModal() {
    return this.$root.itemModal;
  },
  sizes(){
    return this.$root.sizes
  },
  orderingEnabled() {
    return this.$root.orderingEnabled;
  },
  doesDeliverToUser(){
    return this.$root.deliveryStatus.isDeliver || this.$root.isGroupOrderPage;
  },
},

methods: {
   
  isItemParentSelected(parentUUID) {
    let excatSizes = this.flattenExtraCategoriesSizes;
    let isSelected =
      this.flattenSelectedItems.some(
        selectedItem =>
          parentUUID == excatSizes[selectedItem].itemUUID)

    return isSelected
  },
  closeItemModal(){
  this.modalToggler('item-view-modal', 'hide');
  const params = new URLSearchParams(window.location.search);
  params.delete('item');
  window.history.replaceState({}, "", decodeURIComponent(`${window.location.pathname}?${params}`));
  },
  isItemLiked(itemUUID){
   return this.$parent.isItemLiked(itemUUID)
  },
  itemLikeHandler(liked: boolean, itemUUID: string, initialLikes: number) {
    return this.$parent.itemLikeHandler(liked, itemUUID, initialLikes)
  },
  getItemLikes(itemUUID){
   return this.$parent.getItemLikes(itemUUID)
  },
  modalToggler(modalId, method) {
    return this.$root.modalToggler(modalId, method);
  },

  showCreateBasketModal() {
    return this.$root.showCreateBasketModal();
  },
  clearExtras() {
    for (let exCatUUID in this.$root.itemModal.flatExtraCategories) {
      this.$root.itemModal.flatExtraCategories[exCatUUID].selectedItems = [];
    }
  }, 
  revalidateSelectedExtras(){
    this.$root.itemModal.itemData.extraCategories.forEach(exCat =>{
     
      if(!(this.isItemParentSelected(exCat.parentUUID)||exCat.parentUUID== null || exCat.parentUUID==this.itemModal.itemData.itemUUID))
      {
      this.$root.itemModal.flatExtraCategories[exCat.uuid].selectedItems = [];
      }
    })
  },
   collapseHandler(target) {
    this.$root.collapseHandler(target);
  },
  itemSizeChangeHandler() {
    this.calcItemSubTotal();
    for (let exCatUUID in this.$root.itemModal.flatExtraCategories) {
      this.$root.itemModal.flatExtraCategories[exCatUUID].selectedItems = [];
    }
    this.$nextTick(() => {
      removeClassFromSelector("#item-view-modal .item-extras", "hide");

      Array.from(
        document
          .getElementById("item-view-modal")
          .querySelectorAll(".extras-list.size-restricted-list")
      ).forEach((el) => {
        let parent = closestByClass(el, "item-extras")[0];
        el.children.length == 0
          ? parent.classList.add("hide")
          : parent.classList.remove("hide");
      });
    });
  },
  newCalcExtrasTotalPrice(itemExtras) {
      if (!itemExtras) return 0;
      return itemExtras.reduce((exItemsCost, exCat) => exItemsCost + exCat.extraItems.reduce((exCatItemsCost, extraItem) => exCatItemsCost + extraItem.price, 0), 0);
    },
  flatItemSizes(itemsObj) {
    return this.$root.getFlatItemSizes(itemsObj);
  },

  quantityCounter(method) {
    this.$root.itemModal.itemData.quantity = counter(
      method,
      this.$root.itemModal.itemData.quantity
    );
  },
getSizePrice(sizeUUID: string) {
      return this.$root.sizes[sizeUUID].price;
    },
  calcItemSubTotal() {
     this.revalidateSelectedExtras();
      let sizePrice = this.getSizePrice(this.$root.itemModal.itemData.selectedSizeUUID);


      this.$root.itemModal.isExCatsValid = true;

      const sizeQuantityPrice = sizePrice * this.$root.itemModal.itemData.quantity;

      let extrasPrice = 0;
      let isExCatsValid = true;

      for (let exCatUUID in this.$root.itemModal.flatExtraCategories) {
        let exCat = this.$root.itemModal.flatExtraCategories[exCatUUID];

        if (exCat.sizeRestricted) {

          let sizes: any[] = [];

          for (let exSizeUUID in exCat.flatSizes) {

            let exSize = exCat.flatSizes[exSizeUUID];
            exSize.sizeUUID == this.$root.sizes[this.$root.itemModal.itemData.selectedSizeUUID].sizeUUID && sizes.push(exSize);
          }

          (sizes.length && !(exCat.minimumAllowedExtra <= exCat.selectedItems.length)) && (isExCatsValid = false);

        } else {
          !(exCat.minimumAllowedExtra <= exCat.selectedItems.length) && (isExCatsValid = false);
        }



        extrasPrice += exCat.selectedItems.reduce((sum, sizeUUID) => sum + exCat.flatSizes[sizeUUID].price, 0);
      }
      this.$root.itemModal = Object.assign({}, this.$root.itemModal, {
        isExCatsValid,
        itemSubTotal: sizeQuantityPrice + (this.$root.itemModal.itemData.quantity * extrasPrice)
      });

    },
},
});
